/**
 * rb-digioh-tophat — desktop Digioh banner (V16)
 * Plug-and-play: activate any Digioh inline banner in Digioh admin.
 * Desktop non-home: locked above nav, full-bleed proportional scale, hide on scroll only.
 */
(function () {
  /* rb-digioh-failopen-v1 — the CSS that holds a Digioh box hidden until this file has
     classified it keys off this class, so a script that never runs cannot strand a popup
     invisible behind its own dimmer. Set first, before anything that could throw. */
  document.documentElement.classList.add('rb-digioh-js');

  var DESKTOP_MIN = 1000;
  var DESIGN_W_DEFAULT = 1440;
  var RB_DIGIOH_CHROME = '.rb-header, .rb-header-shell, .rb-trust-strip, .rb-age-gate, .rb-pdp-card, .rb-mobile-drawer, #t4s-mini_cart, #t4s-search-hidden, .rb-digioh-tophat';
  var RB_DIGIOH_SEL = [
    '#lightbox-wrapper',
    '[id^="lightbox-inline"]',
    '[id^="lightbox-overlay"]',
    '[id^="box_"]',
    '.lightbox-inline',
    '[class*="lightbox-inline"]',
    'iframe[src*="lightboxcdn"]',
    'iframe[src*="digioh"]',
    '[id*="Lightbox"]',
    '[id*="digioh"]',
    '[class*="digioh-"]'
  ].join(',');

  var lastDigiohOffsetPx = -1;
  var lastDigiohLayoutPx = -1;
  var digiohSyncTimer = 0;
  var displayScale = 1;
  var targetScale = 1;
  var pageHasLoaded = document.readyState === 'complete';
  var RESERVE_H = 110; /* rb-digioh-reserve-v1 — campaign bar slot before measure */
  var reserveReleased = false; /* rb-digioh-mobile-reserve-v1 */

  /* rb-digioh-banner-only-v2 — Digioh ships banners, modals and sidebars through the same
     .preloaded_lightbox shell. Only a banner belongs above the nav: a modal carries its own
     full-page dimmer and scroll lock, so adopting one puts an email form over the menu and
     leaves the storefront sitting behind black.

     v1 read aria-label for this, which looked safe because Digioh writes the label at
     creation. It is not a signal at all: Digioh labels every box "Modal Overlay Box",
     banners included, so the campaign bar classified as a modal, never got adopted, and
     sat on <body> at z-index 9948030 over a nav the theme had offset by 0.

     What does separate them is size and dimmer, both written inline at creation: the modal
     is a 900px dialog with a #sidebar-overlay-<id> behind it, the bar is a <=260px strip
     with nothing behind it. Height is also scroll-invariant, so an adopted bar cannot be
     re-classified out of the header once the reader scrolls. */
  var BANNER_MAX_H = 260;

  function digiohHasPageDimmer(el) {
    return !!(el && el.id && document.getElementById('sidebar-overlay-' + el.id));
  }

  /* Inline height first: Digioh sets it when it creates the box, before layout, and we
     strip it off the bar once it is adopted — at which point the rect is the honest one. */
  function digiohBoxHeight(el) {
    var inline = parseInt((el.style && el.style.height) || '', 10) || 0;
    if (inline > 0) return inline;
    var rectH = Math.round(el.getBoundingClientRect().height || 0);
    if (rectH > 0) return rectH;
    var frame = el.querySelector && el.querySelector('iframe');
    return frame ? (parseInt(frame.getAttribute('height'), 10) || 0) : 0;
  }

  /* Positive test, deliberately: anything we cannot positively read as a bar stays out of
     the header. A box measuring 0 is usually one Digioh has closed, and treating that as a
     banner is how a dismissed modal gets adopted and holds an empty 110px slot open. */
  function isDigiohBannerBox(box) {
    if (digiohHasPageDimmer(box)) return false;
    var h = digiohBoxHeight(box);
    return h >= 16 && h <= BANNER_MAX_H;
  }

  function isDigiohModalBox(el) {
    if (!el) return false;
    var box = el.classList && el.classList.contains('preloaded_lightbox')
      ? el
      : (el.closest ? el.closest('.preloaded_lightbox') : null);
    if (!box) return false;
    var modal = !isDigiohBannerBox(box);
    /* Unhides the box — the CSS holds every unready Digioh box at opacity 0 to keep the
       bar from flashing in at its raw position, and a modal is never going to be "ready". */
    box.classList.toggle('rb-digioh-modal', modal);
    return modal;
  }

  /* Classify every box on the page, not just the ones a lookup happens to walk past.
     digiohBannerBox() stops at the first banner, so a modal sitting after it in the DOM
     would never be marked, and the CSS would hold that modal invisible for good. */
  function tagDigiohBoxes() {
    try {
      var boxes = document.querySelectorAll('.preloaded_lightbox');
      for (var i = 0; i < boxes.length; i++) isDigiohModalBox(boxes[i]);
    } catch (err) {}
  }

  function digiohBannerBox(scope) {
    var root = scope || document;
    try {
      var boxes = root.querySelectorAll('.preloaded_lightbox');
      for (var i = 0; i < boxes.length; i++) {
        if (!isDigiohModalBox(boxes[i])) return boxes[i];
      }
    } catch (err) {}
    return null;
  }

  function isDesktop() {
    /* Match rb-desktop-scale / homepage chrome: a small laptop window with a mouse
       is still desktop. innerWidth < 1000 used to zero the offset and the banner
       dropped back over the nav. */
    if (typeof window.rbIsDesktopClient === 'function' && window.rbIsDesktopClient()) return true;
    return window.innerWidth >= DESKTOP_MIN;
  }

  function isQuickshopOpen() {
    return document.documentElement.classList.contains('rb-pdp-card-open');
  }

  function isHomepage() {
    return !!(document.body && document.body.classList.contains('template-index'));
  }

  function allowsDigioh() {
    return !isHomepage();
  }

  function mountNodeToBody(node) {
    if (!node || node.parentElement === document.body) return;
    var age = document.querySelector('.rb-age-gate');
    if (age && age.parentElement === document.body && age.nextSibling) {
      document.body.insertBefore(node, age.nextSibling);
    } else if (document.body.firstElementChild) {
      document.body.insertBefore(node, document.body.firstElementChild);
    } else {
      document.body.appendChild(node);
    }
  }

  function suppressDigiohOnHomepage() {
    if (!isHomepage()) return;
    document.documentElement.classList.remove('rb-digioh-stacked', 'rb-digioh-ready');
    document.querySelectorAll('.rb-digioh-tophat, .rb-digioh-in-shell').forEach(function (node) {
      node.classList.add('rb-digioh-suppressed');
      node.classList.remove('rb-digioh-in-shell', 'rb-digioh-locked', 'rb-digioh-tophat', 'rb-digioh-ready');
      if (node.closest('.rb-header-shell')) mountNodeToBody(node);
    });
  }

  function pageHasDigiohLightbox() {
    try {
      if (digiohBannerBox()) return true;
      return !!document.querySelector('[id^="lightbox-inline"]');
    } catch (err) {
      return false;
    }
  }

  function setDigiohTophatHeight(px, opts) {
    opts = opts || {};
    var next = Math.max(0, Math.round(px));
    /* rb-digioh-reserve-v1 — never clobber the first-paint 110px slot to 0
       while the campaign lightbox is on the page, or before load on routes
       that Liquid marked .rb-digioh-reserve (lightbox injects ~1s later). */
    if (next === 0 && !isHomepage()) {
      var reserved = document.documentElement.classList.contains('rb-digioh-reserve');
      if (isDesktop()) {
        if (pageHasDigiohLightbox() || (reserved && !pageHasLoaded)) next = RESERVE_H;
      } else if (reserved && !reserveReleased && digiohIsInflow()) {
        /* rb-digioh-mobile-reserve-v3 — only once the banner is actually in flow. Before
           that mobile holds no slot at all, like desktop, so nothing empty is on screen;
           after it, a stray zero measure can't drop the nav back to y=0. */
        next = RESERVE_H;
      }
    }
    /* Always publish layout height for nav offset — never zero when banner is visible */
    var offsetPx = next;
    var offsetVal = offsetPx + 'px';
    /* rb-pdp-tophat-republish-v1 — rewrite if another script zeroed the published var */
    var published = (document.documentElement.style.getPropertyValue('--rb-digioh-tophat-height') || '').trim();
    if (offsetPx === lastDigiohOffsetPx && next === lastDigiohLayoutPx && !opts.forceLayout && published === offsetVal) return next;
    lastDigiohOffsetPx = offsetPx;
    lastDigiohLayoutPx = next;
    var layoutVal = next + 'px';
    document.documentElement.style.setProperty('--rb-digioh-tophat-height', offsetVal);
    document.documentElement.style.setProperty('--rb-digioh-tophat-layout-height', layoutVal);
    if (document.body) {
      document.body.style.setProperty('--rb-digioh-tophat-height', offsetVal);
      document.body.style.setProperty('--rb-digioh-tophat-layout-height', layoutVal);
    }
    if (typeof window.rbSyncPdpArrowTuck === 'function') window.rbSyncPdpArrowTuck();
    return next;
  }

  function isRbThemeChrome(el) {
    if (!el || !el.closest) return false;
    if (el.closest('.rb-digioh-tophat')) return false;
    return !!el.closest(RB_DIGIOH_CHROME);
  }

  function isThemeDocumentRoot(el) {
    return !el || el === document.documentElement || el === document.body;
  }

  function collectDigiohCandidates() {
    var found = [];
    try {
      document.querySelectorAll(RB_DIGIOH_SEL).forEach(function (el) {
        if (!isThemeDocumentRoot(el)) found.push(el);
      });
    } catch (err) {}
    if (!document.body) return found;
    var roots = document.body.children;
    for (var i = 0; i < roots.length; i++) {
      var node = roots[i];
      var id = (node.id || '').toLowerCase();
      var cls = (typeof node.className === 'string') ? node.className.toLowerCase() : '';
      if (id.indexOf('lightbox') !== -1 || id.indexOf('digioh') !== -1 || cls.indexOf('lightbox') !== -1 || cls.indexOf('digioh') !== -1) {
        found.push(node);
      }
    }
    return found;
  }

  function findDigiohTophatRoot() {
    if (!allowsDigioh()) return null;

    var shell = document.querySelector('.rb-header-shell');
    if (shell) {
      var mounted = shell.querySelector('.rb-digioh-tophat, .rb-digioh-in-shell');
      if (mounted) return mounted;
    }

    var preload = digiohBannerBox();
    if (preload && !isRbThemeChrome(preload) && !preload.closest('.rb-pdp-card')) return preload;

    if (document.body) {
      var directBoxes = document.body.querySelectorAll(':scope > [id^="box_"]');
      for (var b = 0; b < directBoxes.length; b++) {
        var box = directBoxes[b];
        if (isRbThemeChrome(box)) continue;
        if (box.querySelector('iframe[src*="lightboxcdn"], iframe[src*="digioh"]')) return box;
      }
    }

    var iframes = document.querySelectorAll('iframe[src*="lightboxcdn"], iframe[src*="digioh"]');
    var best = null;
    var bestTop = Infinity;

    function consider(iframe) {
      if (!iframe || isRbThemeChrome(iframe)) return;
      var rect = iframe.getBoundingClientRect();
      var attrH = parseInt(iframe.getAttribute('height'), 10) || 0;
      var visibleH = rect.height || attrH;
      if (visibleH < 4 && attrH < 12) return;
      if (visibleH > 280) return;
      if (rect.height > 0 && rect.top > 600) return;

      var root = iframe.parentElement;
      while (root && root.parentElement && root.parentElement !== document.body) {
        root = root.parentElement;
      }
      if (!root) root = iframe.parentElement;
      if (!root) return;

      var rank = rect.height > 0 ? rect.top : (attrH > 0 ? 0 : rect.top);
      if (rank < bestTop) {
        bestTop = rank;
        best = root;
      }
    }

    for (var i = 0; i < iframes.length; i++) consider(iframes[i]);
    if (best) return best;

    var candidates = collectDigiohCandidates();
    for (var j = 0; j < candidates.length; j++) {
      var candidate = candidates[j];
      if (isThemeDocumentRoot(candidate) || isRbThemeChrome(candidate)) continue;
      if (candidate.querySelector('iframe[src*="lightboxcdn"], iframe[src*="digioh"]')) return candidate;
    }
    /* Inline Digioh (about:blank iframe + .preloaded_lightbox) — same bar, no vendor src */
    return findInlineTopBanner();
  }

  function syncDigiohChromeStack(el) {
    var root = document.documentElement;
    var shell = document.querySelector('.rb-header-shell');

    if (!isDesktop() || !shell || !allowsDigioh()) {
      root.classList.remove('rb-digioh-stacked');
      if (!allowsDigioh()) suppressDigiohOnHomepage();
      return false;
    }

    if (!el) {
      root.classList.remove('rb-digioh-stacked');
      return false;
    }

    if (el.parentElement !== shell) {
      shell.insertBefore(el, shell.firstChild);
    }
    el.classList.remove('rb-digioh-suppressed');
    el.classList.add('rb-digioh-in-shell');
    root.classList.add('rb-digioh-stacked');
    bindIframeLoad(el);
    return true;
  }

  function bindIframeLoad(el) {
    var iframe = el && el.querySelector('iframe');
    if (!iframe || iframe.getAttribute('data-rb-digioh-load') === '1') return;
    iframe.setAttribute('data-rb-digioh-load', '1');
    iframe.addEventListener('load', function () {
      measureDigiohTophat();
    });
  }

  /* rb-digioh-reserve-v1 — pin chrome to the campaign bar as soon as the
     lightbox exists. Reveal still waits for page load + a real 16–260 measure. */
  function reserveTophatSpace(heightPx) {
    if (!isDesktop() || isHomepage()) return 0;
    var h = Math.max(0, Math.round(heightPx || 0));
    if (h < 16 || h > 260) h = RESERVE_H;
    setDigiohTophatHeight(h, { forceLayout: true });
    syncChromeSpacer();
    return h;
  }

  /* rb-digioh-hold-v1 — one-shot implant after the page is loaded and the bar is locked */
  function revealLockedBanner(el, heightPx) {
    if (!isDesktop() || !el || !pageHasLoaded) return false;
    if (!el.classList.contains('rb-digioh-locked')) return false;
    var h = Math.max(0, Math.round(heightPx || 0));
    if (h < 16 || h > 260) return false;
    el.classList.add('rb-digioh-ready');
    document.documentElement.classList.add('rb-digioh-ready');
    try {
      var iframe = el.querySelector('iframe');
      var idoc = iframe && (iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document));
      killDigiohEntrance(idoc);
    } catch (err) {}
    setDigiohTophatHeight(h, { forceLayout: true });
    syncChromeSpacer();
    return true;
  }

  function captureDigiohDesignHeight(el, iframe) {
    return captureDigiohDesignSize(el, iframe).h;
  }

  /* Digioh's inner #layout is a fixed canvas that is often narrower than our 1440
     chrome (1085px of 1440 at a laptop width). Scaling that canvas to 100% is what
     makes the bar touch both window edges the way it does on a large screen. */
  function captureDigiohDesignSize(el, iframe) {
    var w = 0;
    var h = 0;
    if (iframe) {
      try {
        var doc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        var layout = doc && doc.getElementById('layout');
        if (layout) {
          w = parseInt(layout.style.width, 10) || 0;
          h = parseInt(layout.style.height, 10) || 0;
          if (w < 80) w = layout.offsetWidth || 0;
          if (h < 16 || h > 260) {
            var layoutH = layout.offsetHeight || 0;
            if (layoutH >= 16 && layoutH <= 260) h = layoutH;
            else if (h > 260) h = 0;
          }
        }
      } catch (err) {}
      if (w < 80) w = parseInt(iframe.getAttribute('width'), 10) || 0;
      if (h < 16 || h > 260) {
        var attrH = parseInt(iframe.getAttribute('height'), 10) || 0;
        if (attrH >= 16 && attrH <= 260) h = attrH;
        else h = 0;
      }
    }
    if (w < 80) w = el.offsetWidth || DESIGN_W_DEFAULT;
    /* Never treat a viewport-sized iframe as the bar — that is the full-page flash. */
    if (h < 16 || h > 260) h = 0;
    return { w: w, h: h };
  }

  function ensureDigiohLockWrap(el) {
    var existing = el.querySelector(':scope > .rb-digioh-tophat__lock');
    if (existing) return existing;
    var lock = document.createElement('div');
    lock.className = 'rb-digioh-tophat__lock';
    while (el.firstChild) lock.appendChild(el.firstChild);
    el.appendChild(lock);
    return lock;
  }

  function stripDigiohLayoutStyles(node) {
    if (!node || !node.style) return;
    ['left', 'right', 'top', 'max-width', 'margin', 'margin-left', 'margin-right', 'transform', 'width', 'height'].forEach(function (prop) {
      node.style.removeProperty(prop);
    });
  }

  function applyBannerScale(scale) {
    var root = document.documentElement;
    var el = document.querySelector('.rb-digioh-tophat.rb-digioh-locked');
    if (!el) return;
    var designH = parseInt(getComputedStyle(root).getPropertyValue('--rb-digioh-design-h'), 10) || 74;
    var visualH = Math.max(16, Math.ceil(designH * scale));
    root.style.setProperty('--rb-digioh-banner-scale', String(scale));
    root.style.setProperty('--rb-digioh-visual-h', visualH + 'px');
    if (!el.classList.contains('rb-digioh-ready')) return;
    setDigiohTophatHeight(visualH, { forceLayout: true });
    syncChromeSpacer();
  }

  /* rb-digioh-no-slide-v1 — Digioh's own box often slides/wipes in; freeze it at the end state */
  function killDigiohEntrance(idoc) {
    if (!idoc) return;
    var style = idoc.getElementById('rb-digioh-no-slide');
    if (!style) {
      style = idoc.createElement('style');
      style.id = 'rb-digioh-no-slide';
      style.textContent = 'html,body,#layout,#layout *{animation:none!important;animation-duration:0s!important;transition:none!important;}';
      (idoc.head || idoc.documentElement).appendChild(style);
    }
    try {
      var anims = idoc.getAnimations ? idoc.getAnimations() : [];
      var i;
      for (i = 0; i < anims.length; i++) anims[i].finish();
    } catch (err) {}
    var layout = idoc.getElementById('layout');
    if (layout && layout.style) {
      layout.style.setProperty('animation', 'none', 'important');
      layout.style.setProperty('transition', 'none', 'important');
      layout.style.setProperty('transform', 'none', 'important');
    }
  }

  function syncDigiohProportionalLock(el) {
    if (!el || !document.documentElement.classList.contains('rb-digioh-stacked')) {
      if (el) el.classList.remove('rb-digioh-locked');
      return 0;
    }

    var root = document.documentElement;
    var iframe = el.querySelector('iframe');
    var size = captureDigiohDesignSize(el, iframe);
    var designW = size.w || DESIGN_W_DEFAULT;
    var designH = size.h;
    if (!designH || designH < 16 || designH > 260) return 0;

    ensureDigiohLockWrap(el);
    stripDigiohLayoutStyles(el);
    el.querySelectorAll('.rb-digioh-tophat__lock, .rb-digioh-tophat__lock *').forEach(stripDigiohLayoutStyles);

    var containerW = el.clientWidth;
    if (!containerW || containerW < 80) {
      var pageScale = parseFloat(getComputedStyle(root).getPropertyValue('--rb-desktop-scale')) || 1;
      containerW = root.classList.contains('rb-desktop-scale')
        ? window.innerWidth / pageScale
        : window.innerWidth;
    }

    var nextScale = containerW / designW;
    if (nextScale <= 0) nextScale = 1;

    if (el.classList.contains('rb-digioh-locked') && el.querySelector(':scope > .rb-digioh-tophat__lock')) {
      var prevW = parseInt(getComputedStyle(root).getPropertyValue('--rb-digioh-design-w'), 10) || 0;
      var prevH = parseInt(getComputedStyle(root).getPropertyValue('--rb-digioh-design-h'), 10) || 0;
      if (prevW === designW && Math.abs(prevH - designH) < 2 && Math.abs(nextScale - displayScale) < 0.003) {
        return Math.max(16, Math.ceil(designH * displayScale));
      }
    }

    root.style.setProperty('--rb-digioh-design-w', designW + 'px');
    root.style.setProperty('--rb-digioh-design-h', designH + 'px');
    el.classList.add('rb-digioh-locked');

    if (iframe) {
      iframe.setAttribute('width', String(designW));
      iframe.setAttribute('height', String(designH));
      iframe.style.width = designW + 'px';
      iframe.style.height = designH + 'px';
      iframe.style.minWidth = designW + 'px';
      iframe.style.maxWidth = designW + 'px';
      iframe.style.display = 'block';
      iframe.style.border = '0';
      iframe.style.left = '0';
      iframe.style.margin = '0';
      try {
        var idoc = iframe.contentDocument || (iframe.contentWindow && iframe.contentWindow.document);
        if (idoc && idoc.documentElement) {
          idoc.documentElement.style.background = '#071f45';
          if (idoc.body) idoc.body.style.background = '#071f45';
          killDigiohEntrance(idoc);
        }
      } catch (err) {}
    }

    displayScale = nextScale;
    targetScale = nextScale;
    applyBannerScale(displayScale);
    return Math.max(16, Math.ceil(designH * displayScale));
  }

  function syncDigiohDesktopLayout(el) {
    document.documentElement.classList.remove('rb-digioh-tophat');
    if (document.body) document.body.classList.remove('rb-digioh-tophat');
    document.querySelectorAll('.rb-digioh-tophat').forEach(function (node) {
      if (!el || node !== el || isThemeDocumentRoot(node)) node.classList.remove('rb-digioh-tophat');
    });
    if (!isDesktop() || !el || isThemeDocumentRoot(el)) return;
    el.classList.add('rb-digioh-tophat');
    unstickForcedBanner(el);
    var iframe = el.querySelector('iframe[src*="lightboxcdn"], iframe[src*="digioh"], iframe');
    if (iframe) iframe.classList.add('rb-digioh-tophat__frame');
    if (!el.classList.contains('rb-digioh-ready')) stripDigiohLayoutStyles(el);
  }

  function syncChromeSpacer() {
    var root = document.documentElement;
    if (!root.classList.contains('rb-digioh-stacked')) return;
    if (typeof window.rbSyncHeaderHeight === 'function') window.rbSyncHeaderHeight();
  }

  function clearQuickshopDigioh() {
    document.documentElement.classList.remove('rb-pdp-digioh-stack');
    document.querySelectorAll('.rb-pdp-digioh-banner').forEach(function (node) {
      node.classList.remove('rb-pdp-digioh-banner');
    });
  }

  var BANNER_MARKERS = '[id^="box_"],[id*="lightbox" i],[class*="lightbox" i],[id*="digioh" i],[class*="digioh" i]';

  function bodyLevelRoot(el) {
    var node = el;
    while (node && node.parentElement && node.parentElement !== document.body) node = node.parentElement;
    return (node && node.parentElement === document.body) ? node : el;
  }

  /* Digioh renders a fixed-width strip on mid-size desktops — 718px of a 1024px window —
     so a near-full-bleed test drops the banner exactly where it overlaps the nav most. */
  var BANNER_MIN_WIDTH_RATIO = 0.5;

  /* Below ~1440px the theme scales <html>, so getBoundingClientRect returns painted pixels
     while --rb-digioh-tophat-height is consumed as a CSS length. Feeding the painted height
     straight back in lands the nav short of the banner (78px read for a 110px bar). */
  function desktopPageScale() {
    var root = document.documentElement;
    if (!root.classList.contains('rb-desktop-scale')) return 1;
    var scale = parseFloat(window.getComputedStyle(root).getPropertyValue('--rb-desktop-scale'));
    return scale > 0 ? scale : 1;
  }

  /* Height of el only if it really is a bar sitting across the top of the viewport */
  function topBannerHeight(el) {
    if (!el || el.nodeType !== 1) return 0;
    if (isRbThemeChrome(el)) return 0;
    if (isDigiohModalBox(el)) return 0;
    if (el.closest('.rb-pdp-card')) return 0;
    var cs = window.getComputedStyle(el);
    if (cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) === 0) return 0;
    var r = el.getBoundingClientRect();
    if (r.height < 16 || r.height > 260) return 0;
    if (r.width < window.innerWidth * BANNER_MIN_WIDTH_RATIO) return 0;
    if (r.top < -4 || r.top > 24) return 0;
    return Math.round(r.height / desktopPageScale());
  }

  /* Inline Digioh embeds render as plain HTML — never require an iframe here */
  function findTopBanner() {
    var candidates = [];
    function push(el) {
      if (el && candidates.indexOf(el) === -1) candidates.push(el);
    }
    function add(el) {
      if (isThemeDocumentRoot(el)) return;
      /* The wrapper may be zero-height with the real bar fixed inside it — test both */
      var root = bodyLevelRoot(el);
      if (!isThemeDocumentRoot(root)) push(root);
      push(el);
    }
    try {
      document.querySelectorAll(BANNER_MARKERS).forEach(add);
    } catch (err) {}

    var best = null;
    var bestH = 0;
    var i;
    for (i = 0; i < candidates.length; i++) {
      var h = topBannerHeight(candidates[i]);
      if (h > bestH) { bestH = h; best = candidates[i]; }
    }
    if (best) return best;

    /* No vendor markers matched — take whatever unknown bar is pinned over our nav */
    var kids = document.body ? document.body.children : [];
    for (i = 0; i < kids.length; i++) {
      var node = kids[i];
      if (node.nodeType !== 1) continue;
      var pos = window.getComputedStyle(node).position;
      if (pos !== 'fixed' && pos !== 'sticky') continue;
      var kh = topBannerHeight(node);
      if (kh > bestH) { bestH = kh; best = node; }
    }
    return best;
  }

  /* rb-pdp-digioh-stack-v5 — measure banner while the quickshop is open (both viewports) */
  function shellDigiohBanner() {
    var shell = document.querySelector('.rb-header-shell');
    if (!shell) return null;
    var el = shell.querySelector('.preloaded_lightbox, .rb-digioh-tophat, .rb-pdp-digioh-banner');
    return isDigiohModalBox(el) ? null : el;
  }

  function stableBannerHeight(el) {
    var h = Math.round((el && el.offsetHeight) || 0);
    if (h >= 16 && h <= 260) return h;
    var rectH = el ? Math.round(el.getBoundingClientRect().height || 0) : 0;
    if (rectH >= 16 && rectH <= 260) return rectH;
    if (lastDigiohLayoutPx >= 16) return lastDigiohLayoutPx;
    return RESERVE_H;
  }

  /* rb-digioh-mobile-reserve-v2 — "in the DOM" is not "on screen": the vendor parks the
     box with a negative centring margin and its iframe fills a beat later. Swapping the
     placeholder out before that leaves the banner off to the left, or a gap above the nav
     while the iframe is still empty. The container can't answer this — our own
     min-height keeps it at 110 — so measure the iframe. */
  function digiohBannerPainted(el) {
    if (!el || !el.closest || !el.closest('.rb-header-shell')) return false;
    var frame = el.querySelector('iframe');
    var h = frame ? frame.getBoundingClientRect().height : el.scrollHeight;
    return Math.round(h) >= 16;
  }

  function setDigiohInflow(on) {
    document.documentElement.classList.toggle('rb-digioh-inflow', !!on);
  }

  function digiohIsInflow() {
    return document.documentElement.classList.contains('rb-digioh-inflow');
  }

  function measureQuickshopDigioh() {
    var root = document.documentElement;

    if (!allowsDigioh()) {
      clearQuickshopDigioh();
      return setDigiohTophatHeight(0);
    }

    /* rb-pdp-digioh-stack-mobile-v4 — while the nav is drawered the banner is translated
       off-screen, so its rect reads as "not a top bar" and we would collapse the chrome to
       0 and snap it back on the next pass. Hold the last height until the nav returns. */
    if (root.classList.contains('rb-pdp-nav-hidden')) return lastDigiohLayoutPx;

    /* rb-digioh-mobile-stable-v1 — park in the header shell and keep a stable height.
       Unpinning / viewport-top tests made the bar overlay the nav and flicker. */
    if (pageHasBanner()) placeForcedBanner();
    var el = shellDigiohBanner();
    if (!el && pageHasBanner()) {
      placeForcedBanner();
      el = shellDigiohBanner() || digiohBannerBox();
    }
    if (!el || isThemeDocumentRoot(el)) {
      return setDigiohTophatHeight(lastDigiohLayoutPx >= 16 ? lastDigiohLayoutPx : 0);
    }

    unstickForcedBanner(el);
    el.classList.add('rb-pdp-digioh-banner', 'rb-digioh-tophat');
    root.classList.add('rb-pdp-digioh-stack');
    setDigiohInflow(digiohBannerPainted(el));
    return setDigiohTophatHeight(stableBannerHeight(el));
  }

  /* rb-digioh-inline-desktop-v1 — Digioh's current embed is inline HTML wrapped around an
     about:blank iframe, so findDigiohTophatRoot() (which keys off a lightboxcdn/digioh src)
     never sees it. The banner lands absolute at the document top with a huge z-index while
     .rb-header is fixed, so it covers the nav at every desktop width. Publish how much of
     the banner is still on screen and the header — already top: var(--rb-digioh-tophat-height)
     — trails it, the way the in-flow mobile header does on its own. */
  var inlineBanner = null;
  var inlineScrollRaf = 0;

  function bannerDocTop(el) {
    var r = el.getBoundingClientRect();
    var fixed = window.getComputedStyle(el).position === 'fixed';
    return fixed ? r.top : r.top + (window.pageYOffset || 0);
  }

  /* Same shape as topBannerHeight, but keyed to the document top so a banner the reader
     has already scrolled past still resolves to the element we need to track. */
  function findInlineTopBanner() {
    var best = null;
    var bestH = 0;
    var seen = [];
    function add(el) {
      if (isThemeDocumentRoot(el)) return;
      [bodyLevelRoot(el), el].forEach(function (node) {
        if (node && !isThemeDocumentRoot(node) && seen.indexOf(node) === -1) seen.push(node);
      });
    }
    try {
      document.querySelectorAll(BANNER_MARKERS).forEach(add);
    } catch (err) {}

    for (var i = 0; i < seen.length; i++) {
      var el = seen[i];
      if (el.nodeType !== 1 || isRbThemeChrome(el) || el.closest('.rb-pdp-card')) continue;
      if (isDigiohModalBox(el)) continue;
      var cs = window.getComputedStyle(el);
      if (cs.display === 'none') continue;
      var r = el.getBoundingClientRect();
      if (r.height < 16 || r.height > 260) continue;
      var marked = /lightbox/i.test(el.id || '') || /lightbox/i.test(String(el.className || ''));
      if (!marked && r.width < window.innerWidth * BANNER_MIN_WIDTH_RATIO) continue;
      if (bannerDocTop(el) > 24) continue;
      if (r.height > bestH) {
        bestH = r.height;
        best = el;
      }
    }
    return best;
  }

  function inlineVisibleHeight(el) {
    var r = el.getBoundingClientRect();
    var scale = desktopPageScale();
    var full = Math.round(r.height / scale);
    /* Under rb-desktop-scale the transformed <html> is the containing block for the fixed
       nav, so the nav already travels with the banner as the page scrolls — shrinking the
       offset too would move it twice. Unscaled, the nav is pinned to the viewport and has
       to trail the banner's visible edge itself. */
    /* rb-chrome-pin-v1 — banner stays full height; do not shrink as it scrolls */
    return full;
  }

  function measureInlineDigioh() {
    inlineBanner = findInlineTopBanner();
    if (!inlineBanner) return setDigiohTophatHeight(0);
    return setDigiohTophatHeight(inlineVisibleHeight(inlineBanner));
  }

  function syncInlineDigiohOnScroll() {
    inlineScrollRaf = 0;
    if (!isDesktop() || isQuickshopOpen() || !allowsDigioh()) return;
    if (!inlineBanner || !inlineBanner.isConnected) return;
    setDigiohTophatHeight(inlineVisibleHeight(inlineBanner));
  }

  function queueInlineDigiohScroll() {
    if (inlineScrollRaf) return;
    inlineScrollRaf = window.requestAnimationFrame(syncInlineDigiohOnScroll);
  }

  var measuringTophat = false;

  function measureDigiohTophat() {
    if (measuringTophat) return lastDigiohLayoutPx < 0 ? 0 : lastDigiohLayoutPx;
    measuringTophat = true;
    try {
      return measureDigiohTophatUnguarded();
    } finally {
      measuringTophat = false;
    }
  }

  /* rb-digioh-banner-only-v1 — last line of defence. If a box was adopted before Digioh
     revealed it as a modal, unwrap it and hand it back to the body so the vendor can
     position and close it normally, instead of pinning a dialog above the nav. */
  function releaseAdoptedModal() {
    var adopted = document.querySelector('.rb-header-shell .preloaded_lightbox, .preloaded_lightbox.rb-digioh-tophat');
    if (!adopted || !isDigiohModalBox(adopted)) return false;

    var lock = adopted.querySelector(':scope > .rb-digioh-tophat__lock');
    if (lock) {
      while (lock.firstChild) adopted.insertBefore(lock.firstChild, lock);
      lock.parentElement.removeChild(lock);
    }
    adopted.classList.remove('rb-digioh-tophat', 'rb-digioh-in-shell', 'rb-digioh-locked', 'rb-digioh-ready', 'rb-pdp-digioh-banner');
    var frame = adopted.querySelector('iframe');
    if (frame) {
      frame.classList.remove('rb-digioh-tophat__frame');
      ['min-width', 'max-width', 'left', 'margin'].forEach(function (prop) {
        frame.style.removeProperty(prop);
      });
      frame.style.width = '100%';
      frame.style.height = '100%';
      frame.setAttribute('width', '100%');
      frame.setAttribute('height', '100%');
    }
    mountNodeToBody(adopted);

    var root = document.documentElement;
    root.classList.remove('rb-digioh-stacked', 'rb-digioh-ready', 'rb-digioh-inflow');
    clearQuickshopDigioh();
    setDigiohTophatHeight(0, { forceLayout: true });
    syncChromeSpacer();
    try {
      var api = window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX;
      if (api && typeof api.responsiveResizeCheck === 'function') api.responsiveResizeCheck();
    } catch (err) {}
    return true;
  }

  function measureDigiohTophatUnguarded() {
    var root = document.documentElement;
    tagDigiohBoxes();
    releaseAdoptedModal();
    root.classList.remove('rb-digioh-tophat');
    if (document.body) document.body.classList.remove('rb-digioh-tophat');

    if (!isDesktop()) {
      root.classList.remove('rb-digioh-stacked');
      if (isHomepage()) {
        suppressDigiohOnHomepage();
        clearQuickshopDigioh();
        return setDigiohTophatHeight(0);
      }
      /* rb-chrome-pin-v1 — mobile collection + PDP keep the banner measured and pinned */
      return measureQuickshopDigioh();
    }

    if (isHomepage()) {
      clearQuickshopDigioh();
      suppressDigiohOnHomepage();
      return setDigiohTophatHeight(0);
    }

    /* Desktop quickshop keeps the same full-bleed lock as the collection page.
       (Mobile still uses measureQuickshopDigioh — body scroll is locked there too,
       but the banner is a different pin path.) */
    clearQuickshopDigioh();

    var topEl = findDigiohTophatRoot();
    syncDigiohDesktopLayout(topEl);
    if (topEl && syncDigiohChromeStack(topEl)) {
      var lockedH = syncDigiohProportionalLock(topEl);
      var reserved = reserveTophatSpace(lockedH);
      if (revealLockedBanner(topEl, lockedH)) return lockedH || reserved;
      return reserved;
    }

    if (document.documentElement.classList.contains('rb-digioh-reserve') && (!pageHasLoaded || pageHasDigiohLightbox())) {
      return reserveTophatSpace(RESERVE_H);
    }

    syncDigiohChromeStack(null);
    return measureInlineDigioh();
  }

  function scheduleDigiohSync() {
    if (digiohSyncTimer) return;
    digiohSyncTimer = window.setTimeout(function () {
      digiohSyncTimer = 0;
      measureDigiohTophat();
      if (typeof window.rbSyncHeaderHeight === 'function') window.rbSyncHeaderHeight();
    }, 80);
  }

  function observeDigioh() {
    if (!document.body || typeof MutationObserver === 'undefined') return;
    var mo = new MutationObserver(function (records) {
      var ready = document.documentElement.classList.contains('rb-digioh-ready');
      var i;
      /* rb-digioh-failopen-v1 — classify in the same task the box was inserted in. The
         measure pass below is debounced 80ms, and until a popup is marked the CSS is
         still holding it hidden, so waiting out the debounce is a visible stall on every
         popup. Settles rather than looping: classList.toggle to the value already set
         leaves the attribute alone, so a steady classification emits no record. */
      tagDigiohBoxes();
      for (i = 0; i < records.length; i++) {
        var rec = records[i];
        if (rec.type === 'childList' && (rec.addedNodes.length || rec.removedNodes.length)) {
          scheduleDigiohSync();
          return;
        }
        if (!ready && rec.type === 'attributes') {
          scheduleDigiohSync();
          return;
        }
      }
    });
    mo.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['style', 'class', 'hidden']
    });
  }

  var pdpDigiohTried = false;

  function isProductPage() {
    return !!(document.body && document.body.classList.contains('template-product'));
  }

  function pageHasBanner() {
    /* Do not treat .rb-digioh-tophat as proof — html can pick that class up
       via rb-digioh-reserve matching [class*="digioh-"]. */
    return pageHasDigiohLightbox();
  }

  /* rb-digioh-banner-only-v2 — force-open the campaign bar and nothing else. Taking the
     first configured GUID meant that whenever the bar was unpublished the theme opened
     whichever box Digioh happened to list first — the 30%-off welcome modal. v1 pinned one
     GUID instead, which held until the bar was rebuilt for a new sale: the pinned box was
     gone from the settings, so the theme force-opened nothing at all. Ask Digioh for each
     published box's height instead and take the one shaped like a bar, so activating a new
     banner in the Digioh admin stays plug-and-play. */
  function discoverBannerGuid() {
    try {
      var api = window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX;
      var settings = window.DIGIOH_API && window.DIGIOH_API.DIGIOH_LIGHTBOX_SETTINGS;
      if (!api || !settings) return '';
      var guids = Object.keys(settings);
      for (var i = 0; i < guids.length; i++) {
        var h = 0;
        if (typeof api.getResponsiveBoxHeight === 'function') h = parseInt(api.getResponsiveBoxHeight(guids[i]), 10) || 0;
        if ((h < 16 || h > BANNER_MAX_H) && typeof api.getBoxHeight === 'function') h = parseInt(api.getBoxHeight(guids[i]), 10) || 0;
        if (h >= 16 && h <= BANNER_MAX_H) return guids[i];
      }
    } catch (err) {}
    return '';
  }

  function unstickForcedBanner(el) {
    el = el || digiohBannerBox();
    if (!el || !el.style) return false;
    ['display', 'position', 'z-index', 'left', 'right', 'top', 'bottom', 'margin-left', 'transform'].forEach(function (prop) {
      el.style.removeProperty(prop);
    });
    return getComputedStyle(el).display !== 'none';
  }

  function placeForcedBanner(el) {
    el = el || digiohBannerBox();
    if (!el || isThemeDocumentRoot(el) || isDigiohModalBox(el)) return false;
    unstickForcedBanner(el);
    var shell = document.querySelector('.rb-header-shell');
    if (shell) {
      if (el.parentElement !== shell) shell.insertBefore(el, shell.firstChild);
    } else {
      mountNodeToBody(el);
    }
    el.classList.add('rb-digioh-tophat');
    reserveReleased = false;
    document.documentElement.classList.remove('rb-digioh-noreserve');
    if (typeof window.rbSyncPdpArrowTuck === 'function') window.rbSyncPdpArrowTuck();
    return true;
  }

  function pageHasVisibleBanner() {
    var el = digiohBannerBox();
    if (!el || el.style.display === 'none') return false;
    var r = el.getBoundingClientRect();
    if (r.height < 16) return false;
    if (el.closest('.rb-header-shell')) return true;
    return r.top >= -4 && r.top < 80;
  }

  function ensurePdpDigioh() {
    /* rb-pdp-digioh-reload-v2 — product refresh skips Digioh page rules; force + unhide the collection banner */
    if (isHomepage()) return;
    if (!isProductPage() && !isQuickshopOpen()) return;
    if (!pageHasBanner() && !pdpDigiohTried) {
      var api = window.DIGIOH_API && window.DIGIOH_API.LIGHTBOX;
      if (!api || typeof api.loadLightbox !== 'function') return;
      if (typeof api.isDigiohReady === 'function' && !api.isDigiohReady()) return;
      var guid = discoverBannerGuid();
      if (!guid) return;
      pdpDigiohTried = true;
      try {
        api.loadLightbox(guid, true);
      } catch (err) {}
    }
    if (pageHasBanner()) placeForcedBanner();
    measureDigiohTophat();
  }

  function watchPdpDigioh() {
    if (isHomepage()) return;
    var n = 0;
    var timer = window.setInterval(function () {
      n += 1;
      ensurePdpDigioh();
      if (pageHasBanner()) placeForcedBanner();
      if (pageHasVisibleBanner() || n > 40) window.clearInterval(timer);
    }, 250);
  }

  /* rb-digioh-mobile-reserve-v1 — hand the reserved slot back if Digioh never arrives,
     so the page never keeps an empty navy strip above the nav. */
  function releaseDigiohReserve() {
    if (reserveReleased || pageHasDigiohLightbox()) return;
    reserveReleased = true;
    document.documentElement.classList.add('rb-digioh-noreserve');
    measureDigiohTophat();
  }
  window.setTimeout(releaseDigiohReserve, 6000);

  /* rb-digioh-mobile-reserve-v2 — watch for the banner to finish painting, then hand the
     reserved slot over to it. If it never paints, show it anyway rather than sitting on a
     placeholder forever. */
  function watchDigiohInflow() {
    if (isHomepage() || !document.documentElement.classList.contains('rb-digioh-reserve')) return;
    var n = 0;
    var timer = window.setInterval(function () {
      n += 1;
      var el = shellDigiohBanner();
      if (el && digiohBannerPainted(el)) {
        setDigiohInflow(true);
        measureDigiohTophat();
        window.clearInterval(timer);
        return;
      }
      if (n > 60) {
        if (el) setDigiohInflow(true);
        window.clearInterval(timer);
      }
    }, 100);
  }
  watchDigiohInflow();

  window.rbSyncDigiohTophat = measureDigiohTophat;
  window.rbSyncDigiohChromeSpacer = syncChromeSpacer;
  window.rbFindDigiohTophatRoot = findDigiohTophatRoot;

  if (document.body) observeDigioh();
  else document.addEventListener('DOMContentLoaded', observeDigioh);

  window.addEventListener('scroll', queueInlineDigiohScroll, { passive: true });
  window.addEventListener('resize', scheduleDigiohSync, { passive: true });
  window.addEventListener('load', function () {
    pageHasLoaded = true;
    measureDigiohTophat();
  });
  document.addEventListener('DOMContentLoaded', function () {
    measureDigiohTophat();
    watchPdpDigioh();
  });
  watchPdpDigioh();
  window.setTimeout(measureDigiohTophat, 100);
  window.setTimeout(measureDigiohTophat, 400);
  window.setTimeout(measureDigiohTophat, 1200);
  window.setTimeout(measureDigiohTophat, 5000);
})();
